import { createFileRoute, redirect } from "@tanstack/react-router";
import CalpadsSyncLookupPage from "@/pages/CalpadsSyncLookupPage";
import { isAdminBuild } from "@/utils/isAdminBuild";

export const Route = createFileRoute(
  "/$leaid/_error-wrapper/admin/calpads-sync"
)({
  beforeLoad: ({ context, params }) => {
    if (
      !isAdminBuild() ||
      params.leaid !== "0-" ||
      !context.hasRole("CALPADSSync")
    ) {
      throw redirect({ to: "/$leaid", params: { leaid: params.leaid } });
    }
  },
  component: CalpadsSyncLookupPage,
});
